import { useEffect, useState } from "react";

export default function StickyMobileBookCta() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.65);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const click = () => {
    document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div
      className={`fixed bottom-4 left-4 right-4 z-[95] md:hidden transition-all duration-500 ${
        show ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={click}
        className="wam-btn-primary w-full text-[12px] py-4"
        data-testid="replay-sticky-cta"
      >
        Book A Strategy Call →
      </button>
    </div>
  );
}
